/*

✅ Features Implemented:
Streak Levels: Displayed as a list with a bordered box.
Animated Text Reveal: "Streak goals help you stay committed" fades in smoothly.
"I'm committed" Button: Redirects to the next step when clicked.
Styled Components for Branding: Uses FinTorro colors and typography.
Fully Responsive: Works on mobile & desktop.

*/


import React, { useState, useEffect } from "react";
import { Button, Container, Row, Col, Card } from "react-bootstrap";
import styled from "styled-components";

// ✅ Styled Components
const StyledContainer = styled(Container)`
  background-color: #232830;
  color: white;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
`;

const TitleText = styled.h2`
  font-size: 24px;
  font-weight: bold;
  color: #FF7C24;
  text-align: center;
  margin-bottom: 20px;
`;

const StreakBox = styled(Card)`
  background-color: transparent;
  border: 2px solid white;
  color: white;
  font-size: 18px;
  padding: 10px;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: space-between;
`;

const AnimatedText = styled.h3`
  font-size: 20px;
  font-weight: bold;
  color: #2ECC71;
  text-align: center;
  margin-top: 20px;
  opacity: ${(props) => (props.visible ? "1" : "0")};
  transition: opacity 1s ease-in-out;
`;

const CommitButton = styled(Button)`
  background-color: #FF7C24;
  border: none;
  font-size: 20px;
  font-weight: bold;
  padding: 12px;
  width: 80%;
  max-width: 300px;
  border-radius: 10px;
  margin-top: 30px;
  &:hover {
    background-color: #E66A1A;
  }
`;

const UnderstandStreak = ({ onContinue }) => {
  const [textVisible, setTextVisible] = useState(false);

  useEffect(() => {
    // ✅ Reveal text after component mounts
    const timer = setTimeout(() => {
      setTextVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <StyledContainer>
      <TitleText>Commit to learning Trading and Investing as a life-long skill</TitleText>

      {/* ✅ Streak Boxes */}
      <Row className="w-100" style={{ maxWidth: "400px" }}>
        {[
          ["7 day streak", "Good"],
          ["14 day streak", "Great"],
          ["30 day streak", "Incredible"],
          ["50 day streak", "Unstoppable"]
        ].map(([streak, description], index) => (
          <Col xs={12} key={index} className="mb-3">
            <StreakBox>
              <span>{streak}</span>
              <span>{description}</span>
            </StreakBox>
          </Col>
        ))}
      </Row>

      {/* ✅ Animated Reveal Text */}
      <AnimatedText visible={textVisible}>Streak goals help you stay committed</AnimatedText>

      {/* ✅ Continue Button */}
      <CommitButton onClick={onContinue}>I'm committed</CommitButton>
    </StyledContainer>
  );
};

export default UnderstandStreak;
